module.exports = __webpack_public_path__ + "img/license.c92aeb32.svg";